import useI18nExtended from '~/composables/usei18nExtended'
import {computed} from 'vue'

export const useDesignSpaceHelper = () => {
  const i18n = useI18nExtended()

  const availableResults = computed(() => ({
    designSpaceRadialInShaft: [
      {
        id: 'd5',
        labelLeft: i18n.tv('Frontend.Housing.D5', 'ORingConfiguratorImport'),
        labelRight: i18n.tv('Frontend.Report.ToleranceClass', 'ORingConfiguratorImport'),
        showNumberValue: false
      },
      {
        id: 'd10',
        labelLeft: i18n.tv('Frontend.Housing.D10', 'ORingConfiguratorImport'),
        labelRight: i18n.tv('Frontend.Report.ToleranceClass', 'ORingConfiguratorImport'),
        showNumberValue: false
      },
      {
        id: 'd6',
        labelLeft: i18n.tv('Frontend.Housing.D6', 'ORingConfiguratorImport'),
        labelRight: i18n.tv('Frontend.Report.ToleranceClass', 'ORingConfiguratorImport'),
        showNumberValue: false
      },
      {
        id: 'b1',
        labelLeft: i18n.tv('Frontend.Housing.B1', 'ORingConfiguratorImport'),
        labelRight: `${i18n.tv('Frontend.Report.ToleranceClass', 'ORingConfiguratorImport')}`,
        showNumberValue: true
      }
    ],
    designSpaceRadialInBore: [
      {
        id: 'd9',
        labelLeft: i18n.tv('Frontend.Housing.D9', 'ORingConfiguratorImport'),
        labelRight: i18n.tv('Frontend.Report.ToleranceClass', 'ORingConfiguratorImport'),
        showNumberValue: false
      },
      {
        id: 'd4',
        labelLeft: i18n.tv('Frontend.Housing.D4', 'ORingConfiguratorImport'),
        labelRight: i18n.tv('Frontend.Report.ToleranceClass', 'ORingConfiguratorImport'),
        showNumberValue: false
      },
      {
        id: 'd3',
        labelLeft: i18n.tv('Frontend.Housing.D3', 'ORingConfiguratorImport'),
        labelRight: i18n.tv('Frontend.Report.ToleranceClass', 'ORingConfiguratorImport'),
        showNumberValue: false
      },
      {
        id: 'b1',
        labelLeft: i18n.tv('Frontend.Housing.B1', 'ORingConfiguratorImport'),
        labelRight: `${i18n.tv('Frontend.Report.ToleranceClass', 'ORingConfiguratorImport')}`,
        showNumberValue: true
      }
    ],
    designSpaceAxial: [
      {
        id: 'd8',
        labelLeft: `${i18n.tv('Frontend.Housing.D8', 'ORingConfiguratorImport')}`,
        labelRight: i18n.tv('Frontend.Report.ToleranceClass', 'ORingConfiguratorImport'),
        showNumberValue: false
      },
      {
        id: 'h',
        labelLeft: `${i18n.tv('Frontend.Housing.Height', 'ORingConfiguratorImport')}`,
        labelRight: `${i18n.tv('Frontend.Report.ToleranceClass', 'ORingConfiguratorImport')}`,
        showNumberValue: true
      },
      {
        id: 'b4',
        labelLeft: `${i18n.tv('Frontend.Housing.B4', 'ORingConfiguratorImport')}`,
        labelRight: `${i18n.tv('Frontend.Report.ToleranceClass', 'ORingConfiguratorImport')}`,
        showNumberValue: true
      }
    ]
  }))

  return {
    availableResults
  }
}
